import { actionTypes } from '../../../types';

export const uploadProfilePhotoRequest = (payload, callback) => ({
    type: actionTypes.UPLOAD_PROFILE_PHOTO_REQUEST,
    payload,
    callback,
});

export const uploadProfilePhotoSuccess = (payload) => ({
    type: actionTypes.UPLOAD_PROFILE_PHOTO_SUCCESS,
    payload,
});

export const uploadProfilePhotoFailure = (payload) => ({
    type: actionTypes.UPLOAD_PROFILE_PHOTO_FAILURE,
    payload,
});

export const uploadProfilePhotoReset = () => ({
    type: actionTypes.UPLOAD_PROFILE_PHOTO_RESET,
});

export const uploadProfilePhotoResetAll = () => ({
    type: actionTypes.UPLOAD_PROFILE_PHOTO_RESET_ALL,
});
